import './style.sss';
import axios from 'axios';
import { S, SA, DC, E, RCL, ACL, RCLA, TEXT} from '../../Utilities';


let btn, btnWidget, input, inputWidget, canceledBtn, innerContent;


const controllers = () => {
    E(btn, 'click', () => {
        ACL(btnWidget, 'active');
        input.focus();
    });

    E(input, 'input', e => filter(e.currentTarget.value));
    E(input, 'change', e => startSearch(e.currentTarget.value));
    E(canceledBtn, 'click', () => { input.value = ''; RCL(btnWidget, 'active'); })
};

const loading = e => {
    const loaderEl = DC('img');
    loaderEl.src="/assets/spinner.gif"
    loaderEl.alt = 'loader';
    const ldEl = DC('div');
    ACL(ldEl, 'ld_ell');
    ldEl.appendChild(loaderEl);

    const add = () => {
        innerContent.appendChild(ldEl);
    };

    const destroy = () => {
        ldEl.remove();
    }


    return {
        add,
        destroy
    };
};


const startSearch = async val => {
    innerContent.innerHTML = '';
    const ld = loading();
    ld.add();
    const projecten = await axios.get(`/api/projecten/1/?q=${val}`);
    console.log(projecten);
    ld.destroy();
};

const filter = val => {
    if (val.length > 0) {
        ACL(canceledBtn, 'show');
    } else {
        RCL(canceledBtn, 'show');
    }
};



const view = () => {
    const cancelBtn = () => {
        const b = DC('span');
        const bt = DC('span');
        const bb = DC('span');
        ACL(b, 'close_btn');
        b.appendChild(bt);
        b.appendChild(bb);
        canceledBtn = b;
        return b;
    };
    inputWidget = DC('div');
    const inputWidgetIcon = DC('span');
    ACL(inputWidget, 'search_input_widget');
    ACL(inputWidgetIcon, 'search');
    input = DC('input');
    input.setAttribute('placeholder', 'Zoeken op trefwoord...');
    ACL(input, 'search_input_widget_input');

    inputWidget.appendChild(inputWidgetIcon);
    inputWidget.appendChild(input);
    inputWidget.appendChild(cancelBtn());
    btnWidget.appendChild(inputWidget);
};

export default () => {
    btn = S('.btn_widget .btn_search');
    btnWidget = S('.btn_widget');
    innerContent = S('.projecten_content');

    if (btn) {
        view();
        controllers();
    }
};